module.exports = __webpack_public_path__ + "img/logo-7.961a6bb3.png";